import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fz-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {

  constructor() {
  }

  ngOnInit() { }
}
